<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'user',
      squadList: [],
      items: [
        { label: '账号信息', desc: '登录账号基本信息', type: 'header' },
        // { label: '用户名', name: 'username', value: '', type: 'input' },
        // {label: '用户类型', name: 'user_type', value: 1, type: 'select', dropList:[
        //     {value: 1, name: '普通用户'},
        //     {value: 5, name: '车辆运营员'},
        // ], rules: [{ required: false, trigger: 'blur', type: 'number' }]},
        {
          label: '手机号',
          name: 'user_mobile',
          value: '',
          type: 'input',
          rules: [{ required: true, trigger: 'blur' }],
        },
        {
          label: '登录密码',
          name: 'password',
          value: '',
          type: 'password',
          desc: '更新账户时，如不需要修改密码，请留空',
        },
        { label: '昵称', name: 'user_nick', value: '', type: 'input' },
        {
          label: '头像',
          name: 'user_head',
          value: '',
          type: 'avatar',
          desc: '建议图片宽高尺寸512*512像素及以上',
          rules: [{ required: false, trigger: 'blur' }],
        },
        {
          label: '性别',
          name: 'user_gender',
          value: '',
          type: 'select',
          dropList: [
            { value: 1, name: '男' },
            { value: 2, name: '女' },
            { value: 0, name: '未知' },
          ],
          rules: [{ required: false, trigger: 'blur', type: 'number' }],
        },
        {
          label: '团队',
          name: 'squad_id',
          value: '',
          type: 'select_group',
          multiple: true,
          dropList: [],
          rules: [{ required: false, trigger: 'blur', type: 'array' }],
          onChange: this.changeSquad,
        },
        {
          label: '身份',
          name: 'user_type',
          value: '1',
          type: 'select',
          dropList: [
            { value: 1, name: '游客' },
            { value: 2, name: '普通用户' },
            { value: 3, name: '讲师' },
          ],
          rules: [{ required: false, trigger: 'blur', type: 'number' }],
        },
        { label: '权量', name: 'water_rule_num', value: '', type: 'number' },
        { label: '备注', name: 'remark', value: '', type: 'textarea' },
      ],
      forms: {},
    }
  },
  created() {
    this.init()
  },

  methods: {
    initData() {
      // 加载详情数据
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res
          if (this.forms.squad_list) {
            this.forms.squad_id = this.forms.squad_list
          }
          this.$forceUpdate()
          console.log('initData formsxxxxxxxxxxxxx', this.forms)
          if (this.forms.group_ids) {
            this.forms.group_ids = this.forms.group_ids.split(',')
          }
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        console.log('handleSubmit forms', valid, this.forms)
        if (valid) {
          this.forms.title = this.forms.user_nick
          this.forms.squad_id = this.forms.squad_id.join(',')
          $form.handleSubmit(this)
        }
      })
    },
    async init() {
      let q = {}
      let res = await $utils.api.load('admin/api/squad/dropTree', q)
      if (res && res.data) {
        let ll = res.data
        let dropList = []
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index]
          let xx = {}
          xx.value = element.id
          xx.name = element.name
          xx.disabled = true
          xx.children = element.children || []
          dropList.push(xx)
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index]
          if (element && element.name == 'squad_id') {
            this.items[index]['dropList'] = dropList
          }
        }
        console.log('dropList squad_id', dropList)
      }
    },
  },
}
</script>
